<template>
<div>
    <div v-if="!isLoggedInAs">
      <h4>Log in as:</h4>
  
  
                    <ApolloQuery
    :query="require('./getPartners.gql')"
   
  >
    <template slot-scope="{ result: { data } }">

      <!-- Loading -->
              <el-select v-if="data"
                size="large"
                class="form-group border-input"
                placeholder="Select Partner"
                v-model="partner"
                @change="toggle=false"
              >
                <el-option
                  v-for="option in data.partner"
                  class="select-danger"
                  :value="option.id"
                  :label="option.name"
                  :key="option.id"
                ></el-option>
              </el-select>              </template>
  </ApolloQuery>
  <button v-if="auth.name=='tefl' && !toggle" @click="loginas">Submit</button>
</div>
<div v-if="isLoggedInAs">
    logged in as 
    <h4>{{loggedInAsPartner}}</h4>
    <button  @click="revertToAdmin">Log in as admin</button>
</div>
    </div>
</template>

<script>

import { LOGIN_AS,REVERT } from '../../store/actions/auth'
export default {
  data() {
    return {
partner:'select',
toggle:false
    }
  },
  methods: {
    loginas(){
        this.toggle=!this.toggle;
      this.$store.dispatch(LOGIN_AS , { partner: this.partner})
    .then((resp) => {
        console.log('logged in as',resp)
         this.$emit('input', this.partner);
    })
    
    },
     revertToAdmin(){
       this.toggle=!this.toggle;
      this.$store.dispatch(REVERT )
    .then((resp) => {
        console.log('logged in as',resp)
         this.$emit('input', null);
    })
    
    }
  },
    computed:{
    auth(){
       const profile = this.$store.getters.getProfile
        return profile
        
    },
     isLoggedInAs(){
     
       const loggedInAs = this.$store.getters.loggedInAs
        return loggedInAs
        
    },
    loggedInAsPartner(){
       const loggedInAs = this.$store.getters.loggedInPartner
      
        return loggedInAs
        
    }
  },
   
  
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Customers/Loginas.vue